import React, { useState, useEffect } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, theme } from "antd";
import "./index.css";
const FilterForm = (props) => {
  const { token } = theme.useToken();
  const [form] = Form.useForm();
  const [expand, setExpand] = useState(false);
  const [colAmount, setColAmount] = useState(4);
  const currentForm = props.form || form;

  useEffect(() => {
    const updateColAmount = () => {
      if (props.colAmount) {
        setColAmount(props.colAmount);
        return;
      }
      const colMinWidth = 250; // 每列的最小宽度
      const navWidth = 100 + 24;
      const totalWidth = document.body.clientWidth;
      if (totalWidth >= colMinWidth * 6 + navWidth) {
        setColAmount(6);
      } else if (totalWidth >= colMinWidth * 4 + navWidth) {
        setColAmount(4);
      } else if (totalWidth >= colMinWidth * 3 + navWidth) {
        setColAmount(3);
      } else {
        setColAmount(2);
      }
    };

    updateColAmount();
    window.addEventListener("resize", updateColAmount);
    return () => window.removeEventListener("resize", updateColAmount);
  }, []);

  const formStyle = {
    maxWidth: "none",
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 16,
  };
  const childrenList = props.children;
  const colSpan = Math.floor(24 / colAmount);
  const getFields = () => {
    const spanSum = childrenList.reduce((sum, cur) => (sum + Number(cur.props?.span ?? 1)), 0)
    const needExpand = spanSum >= colAmount * 2;
    const count = expand ? childrenList.length : (needExpand ? colAmount : childrenList.length);
    let currentSpanSum = 0
    const childrenItems = childrenList.slice(0, count).map((child, index) => {
      currentSpanSum += Number(child.props?.span ?? 1)
      return (<Col span={colSpan * Number(child.props?.span ?? 1)} key={index}>{child}</Col>)
    });
    // 计算剩余的列数
    const extraSpan = colAmount - (currentSpanSum % colAmount);
    const operateBtns = (
      <Col
        key="operateBtns"
        span={extraSpan * colSpan}
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {needExpand && (
          <Button
            type="link"
            onClick={() => setExpand(!expand)}
            icon={expand ? <UpOutlined /> : <DownOutlined />}
          >
            {expand ? "收起" : "展开"}
          </Button>
        )}
        <Button onClick={onReset} style={{ marginRight: 8 }}>
          重置
        </Button>
        <Button type="primary" htmlType="submit">
          搜索
        </Button>
      </Col>
    );
    childrenItems.push(operateBtns);

    return childrenItems;
  };
  const onFinish = (values) => {
    props.onFinish?.(values);
  };
  const onReset = () => {
    form.resetFields();
    props.form?.resetFields?.();
    props.onReset?.();
  };

  return (
    <Form
      name="advanced_search"
      style={formStyle}
      onFinish={onFinish}
      className="filter-form"
      form={currentForm}
    >
      <Row gutter={12}>{getFields()}</Row>
    </Form>
  );
};
export default FilterForm;
